import Cookies from 'js-cookie';

function removeTokens() {
  Cookies.remove('accessToken');
  Cookies.remove('isLoggedIn', { domain: '.splashsports.com' });
  Cookies.remove('refreshToken');
  sessionStorage.clear();
  localStorage.clear();
}

export { removeTokens };
